import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import { resetFeatureFlagBypassToken } from '@infraestructure/helpers/feature-flags/feature-flag-bypass.helper';
import { AuthService } from '@infraestructure/drive-adapter/auth/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  if (!inject(AuthService).isAuthenticated()) {
    resetFeatureFlagBypassToken();
    inject(Router).navigate(['/login']);
    return false;
  }
  return true;
};